import React from 'react';
import { Space, Switch, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionMarkTooltip } from 'components/Custom/QuestionMarkTooltip';

interface Props {
  defaultChecked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  tooltip: string;
}

const SwitchLabeled: React.FC<Props> = ({
  defaultChecked,
  onChange,
  label,
  tooltip,
}) => {
  const { t } = useTranslation();

  const [checked, setChecked] = useState(defaultChecked);

  return (
    <Space>
      <span style={{ fontSize: 12 }}>{label}</span>
      <QuestionMarkTooltip title={tooltip} />
      <Tooltip
        title={
          checked
            ? t('common.toggle-on-click-to-turn-off')
            : t('common.toggle-off-click-to-turn-on')
        }
      >
        <Switch
          size="small"
          aria-label={label}
          checked={checked}
          className={checked ? 'switch-checked' : ''}
          onChange={(checked) => {
            setChecked(checked);
            onChange(checked);
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default SwitchLabeled;
